import { ReactNode } from 'react'

const GREEN_CLASS = 'border-green'
const GREEN_ACTIVE_CLASS = 'bg-green text-black'
const GREEN_INACTIVE_CLASS = 'text-green hover:bg-green hover:text-black'

const WHITE_CLASS = 'border-off-white'
const WHITE_ACTIVE_CLASS = 'bg-off-white text-off-white bg-opacity-50'
const WHITE_INACTIVE_CLASS =
  'text-off-white hover:bg-off-white hover:text-black'

export default function OutlineButton({
  children,
  onClick,
  isActive = false,
  variant = 'green',
}: {
  children: ReactNode
  onClick: () => void
  isActive: boolean
  variant?: 'green' | 'white'
}) {
  const baseClass = variant === 'green' ? GREEN_CLASS : WHITE_CLASS
  const activeClass =
    variant === 'green' ? GREEN_ACTIVE_CLASS : WHITE_ACTIVE_CLASS
  const inactiveClass =
    variant === 'green' ? GREEN_INACTIVE_CLASS : WHITE_INACTIVE_CLASS

  return (
    <button
      onClick={onClick}
      className={`mono-large text-14 md:text-sm px-4 md:px-8 h-10 md:h-12 gap-4 rounded-full transition duration-30 border ${baseClass} ${
        isActive ? activeClass : inactiveClass
      }`}
    >
      {children}
    </button>
  )
}
